import nBossConnection from 'modules/base/service/nBossConnection';

class FelhasznalokService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'felhasznalokControl';
	}

	/**
	* @param {number} count
	* @return {Promise<Object>}
	*/
	generatePasswords(count) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/generatePasswords`, { count })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	storeReviewerUsers(userDtos) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/storeReviewerUsers`, { userDtos })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new FelhasznalokService();
